import { Injectable } from '@angular/core';
import { BASE_API_URL } from '@curbnturf/entities';
import { CachedHttpClient } from '@curbnturf/network';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'donation';

@Injectable({
  providedIn: 'root',
})
export class DonationService {
  constructor(private cachedHttp: CachedHttpClient) {}

  makeDonationBoondock(
    boondockId: number,
    amount: number,
    confirmationCode?: string,
    paymentMethod: string = 'CreditCard',
  ): Observable<{ success: boolean; message?: string }> {
    return this.cachedHttp.post<{ success: boolean; message?: string }>(
      `${API_URL}/boondock/${boondockId}`,
      {
        confirmationCode,
        price: amount,
        paymentMethod,
      },
      undefined,
      {
        offlineCallback: () => {
          return { success: true };
        },
      },
    );
  }

  makeDonationPoi(
    poiId: number,
    amount: number,
    paymentMethod: string = 'CreditCard',
  ): Observable<{ success: boolean; message?: string }> {
    return this.cachedHttp.post<{ success: boolean; message?: string }>(
      `${API_URL}/poi/${poiId}`,
      {
        price: amount,
        paymentMethod,
      },
      undefined,
      {
        offlineCallback: () => {
          return { success: true };
        },
      },
    );
  }
}
